import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AppNavbar} from './components/app-navbar/app-navbar';
import {ConsentModal} from './components/consent-modal/consent-modal';
import {AppUpdateNotification} from './components/app-update-notification/app-update-notification';
import {AppUpdateService} from './services/app-update.service';
import {ConsentService} from './services/consent.service';
import {SentryUserService} from './services/sentry-user.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ConsentModal, AppNavbar, AppUpdateNotification],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly appUpdateService = inject(AppUpdateService);
  private readonly consentService = inject(ConsentService);
  // Instantiated at app level so the Sentry user is kept in sync on every page.
  private readonly sentryUserService = inject(SentryUserService);

  protected readonly isConsentBlocking = this.consentService.isBlocking;

  /** Initializes services that must start together with the root application component. */
  constructor() {
    this.appUpdateService.init();
  }
}
